import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageDesktopWebp from './images/sharply-dressed-financial-advisor.webp';
import financialPlanningImageMobileWebp from './images/sharply-dressed-financial-advisor-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='who-we-are-financial-planning-2'
      themeType='lightTheme'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      disableBottomPadding
      reverseContent={false}
      // content
      subHeadingText={<>We believe in the expertise of our <WidowBlock>financial advisors.</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            Your financial go&#45;to. Your trusted partner who helps you continue to reach goal after goal. These expert listeners hear what&#39;s most important to you and put the right financial options and strategies into a personalized plan designed to make it happen. All in a pressure&#45;free, judgment&#45;free environment. Here&#39;s a little more about what it&#39;s like to work&nbsp;
            <Link
              id='who-we-are-financial-planning-2-with-with-our-advisors-link'
              variant='primaryDeemphasize'
              linkUrl='/financial-advisor/'>
              with our financial advisors
            </Link>.
          </Typography>
          <Typography nextElement='typography'>
            Earning accolades and serving as thought leaders across the industry, our advisors bring a broader perspective that goes beyond your portfolio. For those with substantial means, discover our exclusive approach to&nbsp;
            <Link
              id='who-we-are-financial-planning-2-private-wealth-management-link'
              variant='primaryDeemphasize'
              linkUrl='/private-wealth-management/'>
              private wealth management
            </Link>.
          </Typography>
        </>
      )}
      // image props
      imageAltText='A sharply dressed financial advisor.'
      imageSrcDefault={financialPlanningImageDesktopWebp}
      imageSrcMobile={financialPlanningImageMobileWebp}
    />
  );
};
